import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, DefaultButton, Dropdown, Modal, PrimaryButton, TextField } from '@fluentui/react';
import * as Api from '../../../../api/src';
import ModalHeader from '../../../../control/modalHeader';
import { commonfn } from '../../../../common/commonfn';
import { DialogContext } from '../../../../context/dialog.context';
import { ToastAppMsgContext } from '../../../../context/toastApp.Context';
import { ToastAppType } from '../../../../common/constant/enum/toastAppType';
export interface ModaProductProps {
  IsOpen: boolean;
  VendorId?: number | null;
  onCloseModal: () => void;
  onSaveClick?: () => void;
  Item?: any | null;
}
const VendorUserApi = new Api.VendorUserApi();
const UserApi = new Api.UserApi();
const SallingGroupUserApi = new Api.SallingGroupUserApi();
const VendorsApi = new Api.VendorsApi();
const DepartmentsApi = new Api.DepartmentsApi();
const ModulesApi = new Api.ModulesApi();

const ModalUser = ({ Item, IsOpen, onCloseModal, onSaveClick, VendorId }: ModaProductProps) => {
  const { t } = useTranslation();
  const [isShow, SetIsShow] = React.useState(false);
  const [detail, SetDetail] = React.useState<Api.RegisterUserCommand>({} as Api.RegisterUserCommand);
  const [nameErrorMessage, SetNameErrorMessage] = React.useState('');
  const [departmentErrorMessage, SetDepartmentErrorMessage] = React.useState('');
  const [emailErrorMessage, SetEmailErrorMessage] = React.useState('');
  const [vendorErrorMessage, SetVendorErrorMessage] = React.useState('');
  const [listVendor, setListVendor] = React.useState<any[]>([]);
  const [listModules, setListModules] = React.useState<any[]>([]);
  const [selectedKeysModules, setSelectedKeysModules] = React.useState<string[]>([]);
  const [listVendorDB, setListVendorDB] = React.useState<Api.Vendor[]>([]);
  const [listDepartment, setListDepartment] = React.useState<any[]>([]);
  const [listDepartmentDB, setListDepartmentDB] = React.useState<any[]>([]);

  const CompanyTypes = [
    { key: Api.CompanyTypeEnum.SallingGroup, text: t('SallingGroup') },
    { key: Api.CompanyTypeEnum.Vendor, text: t('Vendor') },
  ];
  const [vendorsSelected, setVendorsSelected] = React.useState<number[]>([]);
  const [defaultVendorIds, setDefaultVendorIds] = React.useState<number[]>([]);
  const { setMsgAlertDialog } = React.useContext(DialogContext);
  const { setToastData } = React.useContext(ToastAppMsgContext);
  const [filteredModules, setFilteredModules] = React.useState<any[]>([]);
  const [FilterQuery] = React.useState<Api.GetPagedModulesQuery>({
    PageNumber: 0,
    OrderBy: [],
    PageSize: 0,
    SearchString: '',
    ProductTypeId: 0,
  });
  const filterModules = (
    selectedUserType: string,
    selectedVendorIds?: number[],
    selectedDepartmentId?: number,
    // vendorsManagerSelected?: number[]
  ) => {
    if (selectedUserType === 'Vendor') {
      const vendors = listVendorDB.filter(v => selectedVendorIds?.includes(Number(v?.Id)));
      const productTypeIds = vendors
        .flatMap(vendor => vendor.ProductTypes ?? [])
        .map(pt => pt.Id);
      return listModules.filter(m => productTypeIds.includes(m.ProductTypeId));
    }

    if (selectedUserType === 'SallingGroup') {
      let departmentsFromId: typeof listDepartmentDB = [];
      // let departmentsFromVendors: typeof listDepartmentDB = [];
    
      if (selectedDepartmentId !== undefined) {
        departmentsFromId = listDepartmentDB.filter(
          dept => Number(dept.Id) === Number(selectedDepartmentId)
        );
      }
    
      // if (vendorsManagerSelected && vendorsManagerSelected.length > 0) {
      //   departmentsFromVendors = listVendorDB.filter(
      //     v => vendorsManagerSelected.includes(Number(v?.Id))
      //   );
      // }
    
      //  Lấy Id các ProductType từ mỗi nguồn
      const productTypeIdsFromId = departmentsFromId
        .flatMap(dept => dept.ProductTypes || [])
        .map(pt => pt.Id);
    
      // const productTypeIdsFromVendors = departmentsFromVendors
      //   .flatMap(dept => dept.ProductTypes || [])
      //   .map(pt => pt.Id);
    
      //  Lấy phần giao nhau giữa 2 mảng Id
      // const finalProductTypeIds =
      //   productTypeIdsFromVendors.length > 0
      //     ? productTypeIdsFromId.filter(id => productTypeIdsFromVendors.includes(id))
      //     : productTypeIdsFromId;
    
    
      return listModules.filter(module =>
        productTypeIdsFromId.includes(module.ProductTypeId)
      );
    }
    

    return [];
  };

  React.useEffect(() => {
    const result = filterModules(
      detail?.CompanyType ?? '',
      defaultVendorIds,
      detail?.DepartmentId,
    );
    setFilteredModules(result);
  }, [
    detail?.CompanyType,
    detail?.DepartmentId,
    JSON.stringify(defaultVendorIds),
  ]);



  const dropdownOptions = React.useMemo(() => {
    return filteredModules
      .map(item => ({
        key: item.Id.toString(),
        text: item.Name,
      }));
  }, [filteredModules]);
  React.useEffect(() => {
    if ((filteredModules.length > 0 && Item == null) || detail.Modules == null) {
      const defaultSelected = filteredModules.map((item) => String(item.Id));
      setSelectedKeysModules(defaultSelected);
    }
  }, [filteredModules, detail.Modules]);
  const getItemData = async () => {
    if (Item.CompanyType === Api.CompanyTypeEnum.SallingGroup) {
      var data = (await SallingGroupUserApi.apiSallingGroupUserIdGet(Item?.Id || 0)).data;
      if (data) {
        SetDetail({
          CompanyType: Item.CompanyType,
          FullName: data.UserSallingGroup?.FullName,
          DepartmentId: data.UserSallingGroup?.DepartmentId,
          Email: data.UserSallingGroup?.Email,
          ActivateUser: data.UserSallingGroup?.States === Api.StatesEnum.Active ? true : false,
          ManagedVendors: data.UserSallingGroup?.ManagedVendors,
          IsAdmin: data.IsAdmin,
          Modules: data.UserSallingGroup?.Modules,
        } as Api.RegisterUserCommand);
        setVendorsSelected((data.UserSallingGroup?.ManagedVendors?.map((o) => o.Id) || []) as number[]);
        setSelectedKeysModules(data.UserSallingGroup?.Modules?.split(',') || []);
      }
    } else {
      var dataUserVendor = (await VendorUserApi.apiVendorUserIdGet(Item?.Id || 0)).data;
      if (dataUserVendor) {
        let vendorIds = dataUserVendor.VendorIds?.split(',');
        let ids = [] as number[];
        vendorIds?.forEach(vendorId => {
          ids.push(parseInt(vendorId))
        });
        SetDetail({
          CompanyType: Item.CompanyType,
          FullName: dataUserVendor.FullName,
          ConfirmPassword: '',
          Password: '',
          VendorId: dataUserVendor.VendorId,
          VendorIds: ids,
          Email: dataUserVendor.Email,
          ActivateUser: dataUserVendor.States === Api.StatesEnum.Active ? true : false,
          Modules: dataUserVendor.Modules,
        } as Api.RegisterUserCommand);
        setDefaultVendorIds(ids);
        setSelectedKeysModules(dataUserVendor?.Modules?.split(',') || []);
      }
    }
  };
  React.useEffect(() => {
    SetIsShow(IsOpen);
    getAllVendors();
    getList();
    getAllDepartments();
    if (IsOpen) {
      if (Item == null) {
        SetDetail({
          ActivateUser: true,
          CompanyType: Api.CompanyTypeEnum.Vendor,
          VendorIds: VendorId !== (null || undefined) ? [VendorId] : [],
          AutoConfirmEmail: false,
        } as Api.RegisterUserCommand);
        if (VendorId !== null && VendorId !== undefined) {
          setDefaultVendorIds([VendorId]);
        }
      } else {
        getItemData();
      }
    } else {
      SetDetail({
        ActivateUser: true,
        CompanyType: Api.CompanyTypeEnum.Vendor,
        AutoConfirmEmail: false,
      } as Api.RegisterUserCommand);
      setVendorsSelected([]);
      setDefaultVendorIds([]);
    }
    SetNameErrorMessage('');
    SetEmailErrorMessage('');
    SetDepartmentErrorMessage('');
    SetVendorErrorMessage('');
  }, [IsOpen]);
  const getTitle = (): string => {
    return Item?.Id ? t('EditUser') : t('NewUser');
  };
  const onClose = () => {
    onCloseModal();
    SetIsShow(false);
  };
  const onSave = async () => {
    if (!validateFormData()) return;
    if (detail.CompanyType === Api.CompanyTypeEnum.SallingGroup) {
      detail.ConfirmPassword = null;
      detail.Password = null;
    }
    if (!Item) {
      detail.Modules = selectedKeysModules.map(Number).join(',');
    }
    try {
      var res = null;
      if (!!Item) {
        if (Item.CompanyType === Api.CompanyTypeEnum.SallingGroup) {
          res = await SallingGroupUserApi.apiSallingGroupUserEditPatch({
            ManagedVendors: detail.ManagedVendors,
            FullName: detail.FullName,
            State: detail.ActivateUser ? Api.StatesEnum.Active : Api.StatesEnum.Inactive,
            Id: Item.Id,
            IsAdmin: detail.IsAdmin,
            Modules: selectedKeysModules.map(Number).join(',')

          });
        } else {
          res = await VendorUserApi.apiVendorUserEditPatch({
            FullName: detail.FullName,
            State: detail.ActivateUser ? Api.StatesEnum.Active : Api.StatesEnum.Inactive,
            Id: Item.Id,
            Modules: selectedKeysModules.map(Number).join(',')
          });
        }
      } else {
        res = await UserApi.apiUserPost(detail);
        if (res && res.data.Messages && res.data.Messages[0] === 'EmailIsAlreadyRegistered') {
          setMsgAlertDialog(t('ThisEmailIsAlreadyTaken'));
          return;
        }
      }
      if (!res || res.status !== 200) return;
      setToastData({ Message: t('Successed'), Type: ToastAppType.Success });
      onCloseModal();
      SetIsShow(false);
      if (onSaveClick) {
        onSaveClick();
      }
    } catch (error) { }
  };
  const validateFormData = () => {
    let pass = true;
    if (!detail?.FullName) {
      SetNameErrorMessage(t('IsRequired').replace('{0}', t('FullName')));
      pass = false;
    }

    if (!detail?.Email) {
      SetEmailErrorMessage(t('IsRequired').replace('{0}', t('Email')));
      pass = false;
    } else if (!commonfn.validateEmail(detail?.Email)) {
      SetEmailErrorMessage(t('InvalidEmailAddress'));
      pass = false;
    }
    if (detail.CompanyType === Api.CompanyTypeEnum.SallingGroup) {
      if (!detail?.DepartmentId) {
        SetDepartmentErrorMessage(t('IsRequired').replace('{0}', t('Department')));
        pass = false;
      }
    } else {
      if (!detail?.VendorIds?.length) {
        SetVendorErrorMessage(t('IsRequired').replace('{0}', t('Vendor')));
        pass = false;
      }
    }
    return pass;
  };
  const getList = async () => {
    let data = (await ModulesApi.apiModulesPagedPost(FilterQuery)).data;
    setListModules(data?.Data ?? []);

  };
  const getAllVendors = async () => {
    if (listVendor.length > 0) return;
    let data = (
      await VendorsApi.apiVendorsPagedPost({
        PageNumber: 1,
        OrderBy: [{ ColumnName: 'Name' }],
        PageSize: 0,
        SearchString: '',
        GetOnlyActive: true,
      })
    ).data;
    let vendors: any[] = [];
    data.Data?.forEach((element) => {
      vendors.push({ key: element.Id, text: element.Name });
    });
    if (!vendors.length) {
      vendors.push({
        key: null,
        text: t('NoDataFound'),
        disabled: true,
      });
    }
    setListVendorDB(data.Data || []);
    setListVendor(vendors);
  };
  const getAllDepartments = async () => {
    if (listDepartment.length > 0) return;
    let data = (
      await DepartmentsApi.apiDepartmentsPagedPost({
        PageNumber: 1,
        OrderBy: [{ ColumnName: 'Name' }],
        PageSize: 0,
        SearchString: '',
        GetOnlyActive: true,
      })
    ).data;
    let departments: any[] = [];
    data.Data?.forEach((element) => {
      departments.push({ key: element.Id, text: element.Name });
    });
    if (!departments.length) {
      departments.push({
        key: null,
        text: t('NoDataFound'),
        disabled: true,
      });
    }
    setListDepartment(departments);
    setListDepartmentDB(data.Data || []);
  };
  return (
    <Modal isOpen={isShow} isModeless={true}>
      <ModalHeader
        title={getTitle()}
        onCloseModal={() => {
          onClose();
        }}
      />
      <div className={'modal-content'} style={{ width: 700 }}>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-md6 padding-left-0 ms-Grid-col">
              <TextField
                label={t('FullName') + ' (*)'}
                errorMessage={nameErrorMessage}
                value={detail?.FullName || ''}
                onChange={(e, newValue) => {
                  SetDetail({ ...detail, FullName: newValue || '' });
                  SetNameErrorMessage('');
                }}
              ></TextField>
            </div>
            <div className="ms-md6 padding-right-0 ms-Grid-col">
              <TextField
                label={t('Email') + ' (*)'}
                value={detail?.Email || ''}
                errorMessage={emailErrorMessage}
                autoComplete="none"
                onChange={(e, newValue) => {
                  SetDetail({ ...detail, Email: newValue || '' });

                  SetEmailErrorMessage('');
                }}
                disabled={Item}
              ></TextField>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-md6 margin-0 padding-left-0 ms-Grid-col">
              <Dropdown
                options={CompanyTypes}
                label={t('UserType')}
                selectedKey={detail?.CompanyType || ''}
                placeholder={t('Select')}
                disabled={Item}
                onChange={(e, opt) => {
                  if (opt?.key) {
                    SetDetail({ ...detail, CompanyType: (opt?.key || '') as Api.CompanyTypeEnum });
                  }
                }}
              ></Dropdown>
            </div>
            <div className="ms-md6 margin-0 padding-right-0 ms-Grid-col">
              {detail.CompanyType === Api.CompanyTypeEnum.Vendor ? (
                Item ? (
                  <Dropdown
                    options={listVendor}
                    multiSelect
                    label={t('Vendor') + ' (*)'}
                    errorMessage={vendorErrorMessage}
                    selectedKeys={defaultVendorIds}
                    placeholder={t('Select')}
                    disabled={true}
                  />
                ) : (
                  <Dropdown
                    options={listVendor}
                    multiSelect
                    label={t('Vendor') + '(*)'}
                    errorMessage={vendorErrorMessage}
                    defaultSelectedKeys={defaultVendorIds}
                    placeholder={t('Select')}
                    disabled={Item}
                    onChange={(e, opt) => {
                      if (opt?.key) {
                        if (!detail.VendorIds) {
                          detail.VendorIds = [];
                        }
                        if (opt.selected) {
                          if (!detail.VendorIds.find(o => o === opt.key)) {
                            let item = listVendor.find((o) => o.key === opt.key);
                            if (item) {
                              detail.VendorIds.push(item.key);
                            }
                          }
                        } else {
                          detail.VendorIds = detail.VendorIds.filter((o) => o !== opt?.key);
                        }
                        setSelectedKeysModules([]);
                        setDefaultVendorIds(detail.VendorIds || []);
                        SetDetail({ ...detail });
                      }
                      SetVendorErrorMessage('');
                    }}
                  ></Dropdown>
                )
              ) : (
                <Dropdown
                  options={listDepartment}
                  label={t('Department') + ' (*)'}
                  errorMessage={departmentErrorMessage}
                  selectedKey={detail?.DepartmentId || 0}
                  disabled={Item}
                  placeholder={t('Select')}
                  onChange={(e, opt) => {
                    if (opt?.key) {
                      SetDetail({ ...detail, DepartmentId: parseInt(opt.key.toString(), 10) });
                      setSelectedKeysModules([]);
                    }
                    SetDepartmentErrorMessage('');
                    
                  }}
                />
              )}
            </div>

          </div>
          {detail.CompanyType === Api.CompanyTypeEnum.SallingGroup && (
            <div className="ms-Grid-row">
              <div className="ms-md12 margin-0 padding-right-0  padding-left-0 ms-Grid-col">
                <Dropdown
                  options={listVendor}
                  multiSelect
                  label={t('VendorManager')}
                  selectedKeys={vendorsSelected}
                  placeholder={t('Select')}
                  onChange={(e, opt) => {
                    if (listVendor && opt?.key) {
                      if (opt.selected) {
                        if (!detail.ManagedVendors) {
                          detail.ManagedVendors = [];
                        }
                        if (!detail.ManagedVendors.find((o) => o.Id === opt?.key)) {
                          let item = listVendorDB.find((o) => o.Id === opt?.key);
                          if (item) {
                            detail.ManagedVendors?.push(item);
                          }
                        }
                      } else {
                        detail.ManagedVendors = detail.ManagedVendors?.filter((o) => o.Id !== opt?.key);
                      }
                      SetDetail({ ...detail });
                      setVendorsSelected((detail.ManagedVendors?.map((o) => o.Id) || []) as number[]);
                    }
                  }}
                ></Dropdown>
              </div>
            </div>
          )}
          <div className="ms-Grid-row">
            <div className="ms-md12 margin-0 padding-right-0 padding-left-0 ms-Grid-col">
              <Dropdown
                options={dropdownOptions}
                multiSelect
                label={t('Modules')}
                placeholder={t('Select')}
                selectedKeys={selectedKeysModules}
                onChange={(event, option) => {
                  if (!option) return;

                  const key = option.key.toString();
                  const isSelected = selectedKeysModules.includes(key);

                  const updatedSelectedKeys = isSelected
                    ? selectedKeysModules.filter((k) => k !== key)
                    : [...selectedKeysModules, key];

                  setSelectedKeysModules(updatedSelectedKeys);
                }}

              />
            </div>
          </div>

          {detail.CompanyType === Api.CompanyTypeEnum.SallingGroup && (
            <div className="ms-Grid-row">
              <div className="ms-md6 margin-0 padding-left-0 ms-Grid-col">
                <Checkbox
                  label={t('Administrator')}
                  checked={detail?.IsAdmin}
                  onChange={(e, checked) => {
                    SetDetail({ ...detail, IsAdmin: checked });
                  }}
                ></Checkbox>
              </div>
            </div>
          )}
          <div className="ms-Grid-row">
            <div className="ms-md6 margin-0 padding-left-0 ms-Grid-col">
              <Checkbox
                label={t('Active')}
                checked={detail?.ActivateUser}
                onChange={(e, checked) => {
                  SetDetail({ ...detail, ActivateUser: checked });
                }}
              ></Checkbox>
            </div>
          </div>
        </div>
      </div>
      <div className={'modal-footer'}>
        <DefaultButton
          onClick={() => {
            onClose();
          }}
          className={'margin-left-10'}
        >
          {t('Close')}
        </DefaultButton>
        <PrimaryButton
          className={'margin-left-10'}
          onClick={() => {
            onSave();
          }}
        >
          {t('Save')}
        </PrimaryButton>
      </div>
    </Modal>
  );
};
export default ModalUser;
